import React from 'react';
import style from './spinner.scss';

export function Spinner(props) {
    return (
      <div className={`${style.loader} ${props.className ? props.className : ''}`}/>
    );
}